import {Pipe, PipeTransform} from '@angular/core';
import {
    BdReceivableDescriptor,
    describeReceivable
} from '../../../util/bd-receivable-amount.util';

/**
 * Liefert den UI-Deskriptor (Label, Farbe, Magnitude, formatierter Betrag) für
 * einen Saldo-Betrag nach der modulweiten Konvention **offen = positiv** (U01).
 *
 * Verwendung im Template:
 *   @let d = amount | bdReceivable:'EUR';
 *   <span [class]="d.colorClass">{{ d.label }}: {{ d.formatted }}</span>
 *
 * Der Magnitude wird stets positiv ausgewiesen — die Bedeutung steckt im Label
 * (Forderung rot / Guthaben grün), nicht im Minuszeichen.
 */
@Pipe({
    name: 'bdReceivable',
    standalone: false
})
export class BdReceivableAmountPipe implements PipeTransform {

    transform(
        amount: number | null | undefined,
        currency: string = 'EUR'
    ): BdReceivableDescriptor {
        return describeReceivable(amount, currency);
    }
}
